var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPost = function SvgPost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 91,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.709 74.464h54.68v4.39h-50.29c-2.42 0-4.39-1.97-4.39-4.39Z",
    fill: "#4249BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.413 32.956h31.735c11.722 0 21.235 9.52 21.235 21.236v20.265H51.178V54.192c0-11.723 9.52-21.236 21.236-21.236Z",
    fill: "url(#Post_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.199 33.013c8.844 0 16.022 7.184 16.022 16.022v25.429H51.17v-25.43c0-8.844 7.184-16.021 16.022-16.021h.007Z",
    fill: "#4249BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.231 74.464h37.99v4.39H49.622c-2.42 0-4.39-1.97-4.39-4.39Z",
    fill: "url(#Post_svg__b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.297 78.855h-6.086v12.088h6.086V78.855Z",
    fill: "#545DF1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.648 26.308h20.067a5.543 5.543 0 0 1-5.537 5.537h-14.53v-5.537Z",
    fill: "#E3B354"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.952 43.21V24.991a2.25 2.25 0 0 1 2.252-2.252 2.249 2.249 0 0 1 2.251 2.252v18.217",
    fill: "#DC9B32"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.646 24.862a3.9 3.9 0 0 0-2.906-.661l-43.605 7.353a3.904 3.904 0 0 0-2.59 1.667l27.147 11.596 21.954-19.955Z",
    fill: "#727AFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.544 33.215a3.898 3.898 0 0 0-.62 2.842l4.483 26.59c.042.268.112.522.21.768L43.69 44.818 16.544 33.215ZM71.73 53.993l-4.482-26.59a3.922 3.922 0 0 0-1.604-2.548L43.69 44.81 71.773 54.93c.02-.31.014-.62-.043-.943v.007Z",
    fill: "#9EA3F3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m24.917 65.856 43.605-7.353c1.815-.303 3.117-1.815 3.25-3.568L43.69 44.817 20.618 63.414a3.911 3.911 0 0 0 4.3 2.442Z",
    fill: "#727AFF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M63.147 27.13 43.69 44.812 19.732 34.574l-4.06-24.092c-.352-2.083 1.147-4.068 3.335-4.433L54.5.06c2.195-.373 4.257 1.013 4.609 3.096l4.039 23.973Z",
    fill: "#ECEFF1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m28.207 16.579-6.474 1.091a.596.596 0 0 0-.49.686.596.596 0 0 0 .688.487l6.474-1.092a.596.596 0 0 0 .49-.686.596.596 0 0 0-.688-.486ZM33.825 15.633l-3.046.514a.596.596 0 0 0-.49.685.596.596 0 0 0 .688.487l3.046-.513a.596.596 0 0 0 .49-.686.596.596 0 0 0-.688-.487ZM43.644 18.244l-2.075.35a.596.596 0 0 0-.49.685.596.596 0 0 0 .688.487l2.075-.35a.596.596 0 0 0 .49-.685.596.596 0 0 0-.688-.487ZM48.066 22.612l-2.075.35a.596.596 0 0 0-.49.686.596.596 0 0 0 .688.487l2.074-.35a.596.596 0 0 0 .491-.686.596.596 0 0 0-.688-.487ZM48.514 17.424l-2.075.35a.596.596 0 0 0-.49.685.596.596 0 0 0 .688.487l2.075-.35a.596.596 0 0 0 .49-.685.596.596 0 0 0-.688-.487ZM25.913 29.798l-2.074.35a.596.596 0 0 0-.491.685.596.596 0 0 0 .689.487l2.074-.35a.596.596 0 0 0 .491-.685.596.596 0 0 0-.689-.487ZM30.81 28.975l-2.074.35a.596.596 0 0 0-.49.685.596.596 0 0 0 .688.487l2.075-.35a.596.596 0 0 0 .49-.685.596.596 0 0 0-.688-.487ZM35.679 28.155l-2.075.35a.596.596 0 0 0-.49.686.596.596 0 0 0 .688.486l2.075-.35a.596.596 0 0 0 .49-.685.596.596 0 0 0-.688-.487ZM41.165 14.396l-4.816.812a.596.596 0 0 0-.49.686.596.596 0 0 0 .688.487l4.816-.812a.596.596 0 0 0 .49-.686.596.596 0 0 0-.688-.487ZM43.66 23.355l-20.386 3.437a.596.596 0 0 0-.49.686.596.596 0 0 0 .688.487l20.385-3.437a.596.596 0 0 0 .491-.686.596.596 0 0 0-.688-.487ZM25.15 11.64a2.484 2.484 0 1 0-4.9.826 2.484 2.484 0 0 0 4.9-.826ZM55.546 3.994 44.188 5.91l.466 2.768 11.359-1.914-.467-2.769Z",
    fill: "#E3B354"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m12.09 36.938-4.623.718M11.02 44.101l-8.176 1.267M13.842 51.257l-6.375.992M13.841 58.42 1 60.41",
    stroke: "#E3B354",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.15 19.451v3.286M82.79 21.09h-3.285",
    stroke: "#E3B354",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.758 19.923a.915.915 0 1 0 0-1.83.915.915 0 0 0 0 1.83Z",
    stroke: "#E3B354",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M134.684 61.177a1.646 1.646 0 1 0 0-3.293 1.646 1.646 0 0 0 0 3.293Z",
    stroke: "#E3B354",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m26.957 77.882-1.984 3.44h3.975l-1.991-3.44Z",
    stroke: "#E3B354",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Post_svg__a",
    x1: 113.302,
    y1: 44.84,
    x2: 29.921,
    y2: 88.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#545DF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Post_svg__b",
    x1: 50.255,
    y1: 84.695,
    x2: 118.36,
    y2: 45.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#545DF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB0F9"
  })))));
};
export default SvgPost;